import { AsyncHelper } from './../../framework/async-helper';
import { Logger, LoggerFactory } from './logger.service';
import { EventEmitter, Injectable } from '@angular/core';

export interface LoaderState {
  isBusy: boolean;
}

@Injectable()
export class LoaderService {
  private readonly logger: Logger;
  private busyOperations = 0;
  public readonly onStateChanged = new EventEmitter<LoaderState>(true);

  constructor(loggerFactory: LoggerFactory) {
    this.logger = loggerFactory.get('LoaderService');
  }

  public setBusy(): void {
    this.busyOperations++;
    if (this.isBusy()) {
      this.onStateChanged.emit({ isBusy: true });
    }
  }

  public removeBusy(): void {
    if (this.busyOperations > 0) {
      this.busyOperations--;
    }
    if (!this.isBusy()) {
      this.onStateChanged.emit({ isBusy: false });
    }
  }

  public waitForCurrentBusyStateToEndAsync(): Promise<void> {
    // TODO: Optimize it by using the exisitn event.
    return AsyncHelper.waitUntilTrueAsync(
      () => !this.isBusy(),
      () => Promise.resolve(),
      () => Promise.reject('View is never initialized'),
    );
  }

  public isBusy(): boolean {
    return this.busyOperations > 0;
  }
}
